export interface IQuotaBaseRule {
  $type: string;
}

export class AssetObjectTreeStorageSizeQuota implements IQuotaBaseRule {
  $type = "VDM.AirLab.Sdk.Core.Database.Types.Quota.AssetObjectTreeStorageSizeQuota, VDM.AirLab.Sdk.Core";
  maxSizeInBytes: number = 0;

  constructor(init?: Partial<AssetObjectTreeStorageSizeQuota>) {
    Object.assign(this, init);
  }
}
